









































































import Vue from 'vue';

import AppBar from '@/components/AppBar.vue';
import Note from '@/components/Note.vue';
import Footer from '@/components/Footer.vue';

export default Vue.extend({
  components: {
    AppBar,
    Note,
    Footer,
  },
  data(): {
    editing: boolean;
    initialSpaces: any[];
    initialOwnership: boolean;
    sharing: string | null;
  } {
    return {
      editing: false,
      initialSpaces: [],
      initialOwnership: false,
      sharing: null,
    };
  },
  computed: {
    note(): any {
      return this.$store.state.note;
    },
    spaces(): { owner: string; id: string }[] {
      // TODO: Fix: Ref gets unbound after update
      const owners = this.note
        ? this.note.owners.filter((owner: any) => owner !== null)
        : [];
      if (owners.length > 0 && !owners[0].space) {
        return this.initialSpaces;
      }
      const spaces = owners.map((owner: any) => {
        return {
          owner: `/users/${owner.id}`,
          id: owner.space.replace('spaces/', ''),
        };
      });
      if (spaces.length > 0) {
        this.initialSpaces = spaces;
      }
      return spaces;
    },
    draft(): string | null {
      return this.$store.state.user.draft.id;
    },
    initialSharing(): string | null {
      return this.note ? this.note.sharing : null;
    },
    isOwner(): boolean {
      if (this.$store.state.userInfoRef === null) {
        return false;
      }
      const owners = this.note ? this.note.owners : [];
      if (owners.length > 0 && !owners[0].id) {
        return this.initialOwnership;
      }
      const ownership = owners
        .map((owner: any) => owner.id)
        .includes(this.$store.state.userInfoRef.id);
      this.initialOwnership = ownership;
      return ownership;
    },
  },
  watch: {
    initialSharing() {
      this.sharing = this.sharing ? this.sharing : this.initialSharing;
    },
  },
  filters: {
    formatDate(seconds: number) {
      const formatted = seconds
        ? new Date(seconds * 1000).toLocaleString()
        : '';
      return formatted;
    },
  },
  methods: {
    isDraft() {
      return !this.$route.params.noteid;
    },
    async save() {
      const noteRef: any = this.$refs.note;
      const doc = noteRef.getJSON();
      // const doc = this.note.doc;
      await this.$store
        .dispatch('saveNote', {
          doc,
          sharing: this.sharing,
        })
        .catch((err) => {
          console.log('Error:', err);
        });
      this.$router.push('/');
    },
    async remove() {
      await this.$store.dispatch('removeNote').catch((err) => {
        console.log('Error:', err);
      });
      this.$router.push('/');
    },
  },
  created() {
    if (this.$route.name == 'note-new') {
      this.editing = true;
    }
  },
  mounted() {},
});
